import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";

export const OrganizationTaskTemplateBulkCommandsList: FC<
    CommandsListProps
> = ({ options = {} }) => {
    const {
        selectedOrganizationTaskTemplateCount = 0,
        onOrganizationTaskTemplateBulkArchive,
        onOrganizationTaskTemplateBulkEnable,
        onOrganizationTaskTemplateBulkDetach,
        onOrganizationTaskTemplateBulkDelete,
    } = options;

    const heading = `${pluralizeWithCount("task template", selectedOrganizationTaskTemplateCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onOrganizationTaskTemplateBulkArchive && (
                <CommandItem
                    keywords={["archive"]}
                    onSelect={onOrganizationTaskTemplateBulkArchive}
                >
                    Archive
                </CommandItem>
            )}
            {onOrganizationTaskTemplateBulkEnable && (
                <CommandItem
                    keywords={["enable", "unarchive", "restore"]}
                    onSelect={onOrganizationTaskTemplateBulkEnable}
                >
                    Enable
                </CommandItem>
            )}
            {onOrganizationTaskTemplateBulkDetach && (
                <CommandItem
                    keywords={["detach", "unlink"]}
                    onSelect={onOrganizationTaskTemplateBulkDetach}
                >
                    Detach
                </CommandItem>
            )}
            {onOrganizationTaskTemplateBulkDelete && (
                <CommandItem
                    keywords={["delete", "remove"]}
                    shortcut="delete"
                    onSelect={onOrganizationTaskTemplateBulkDelete}
                >
                    Delete
                </CommandItem>
            )}
        </Command.Group>
    );
};
